(function () {
  'use strict';
  if (window.ffProductReviewsLoaded) return;
  window.ffProductReviewsLoaded = true;

  function httpsUrl(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      var url = new URL(value, document.baseURI);
      return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
    } catch (error) { return ''; }
  }
  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = String(text);
    return node;
  }
  function cleanText(value) { return typeof value === 'string' ? value.trim() : ''; }
  function mediaUrls(values) { return Array.isArray(values) ? values.map(httpsUrl).filter(Boolean) : []; }
  function formatDate(date) {
    var time = Date.parse(date);
    return Number.isFinite(time) ? new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }).format(time) : '';
  }
  function normalizedReview(item, index) {
    if (!item || typeof item !== 'object') return null;
    var rating = Number(item.rating);
    if (!Number.isInteger(rating) || rating < 1 || rating > 5) return null;
    var body = cleanText(item.body);
    var title = cleanText(item.title);
    var images = mediaUrls(item.images);
    var videos = [], videoPosters = [];
    if (Array.isArray(item.videos)) item.videos.forEach(function (url, videoIndex) { var safe = httpsUrl(url); if (safe) { videos.push(safe); videoPosters.push(Array.isArray(item.videoPosters) ? httpsUrl(item.videoPosters[videoIndex]) : ''); } });
    return {
      id: String(item.id || index), author: cleanText(item.author) || 'Customer', rating: rating,
      date: cleanText(item.date), timestamp: Date.parse(item.date) || 0, title: title, body: body,
      variant: cleanText(item.variant), variantId: String(item.variantId || ''),
      verifiedAtSource: item.verifiedAtSource === true, images: images, videos: videos,
      videoPosters: videoPosters,
      response: item.response && cleanText(item.response.body) ? { body: cleanText(item.response.body), date: cleanText(item.response.date) } : null,
      sourceIndex: index
    };
  }
  function init(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-ff-reviews]')) roots.push(scope);
    roots = roots.concat(Array.from(scope.querySelectorAll('[data-ff-reviews]')));
    roots.forEach(function (root) {
      if (root.dataset.reviewsReady === '1') return;
      root.dataset.reviewsReady = '1';
      var feedUrl = httpsUrl(root.dataset.feedUrl || '');
      if (!feedUrl) return;
      var get = function (selector) { return root.querySelector(selector); };
      var list = get('[data-review-list]');
      var status = get('[data-review-status]');
      var overview = get('[data-review-overview]');
      var controls = get('[data-review-controls]');
      var source = get('[data-review-source]');
      var distribution = get('[data-review-distribution]');
      var variantSelect = get('[data-review-variant]');
      var sortSelect = get('[data-review-sort]');
      var mediaOnly = get('[data-review-media-only]');
      var clearButton = get('[data-review-clear]');
      var moreButton = get('[data-review-more]');
      var retryButton = get('[data-review-retry]');
      var dialog = get('[data-review-dialog]');
      var mediaContainer = get('[data-review-dialog-media]');
      var dialogClose = get('[data-review-dialog-close]');
      var originalMedia = get('[data-review-original-media]');
      var reviews = [];
      var selectedStars = 0;
      var visibleLimit = 6;
      var state = 'idle';
      var opener = null;
      var observer = null;
      var sourceName = 'the original store';

      function closeMedia() { if (dialog.open) dialog.close(); }
      dialogClose.addEventListener('click', closeMedia);
      dialog.addEventListener('click', function (event) { if (event.target === dialog) { var bounds = dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeMedia(); } });
      dialog.addEventListener('close', function () { var playing = mediaContainer.querySelector('video'); if (playing) playing.pause(); mediaContainer.replaceChildren(); if (opener && opener.isConnected) opener.focus(); });

      function showMedia(url, kind, review, button, poster) {
        if (!httpsUrl(url)) return;
        if (typeof dialog.showModal !== 'function') { window.open(url, '_blank', 'noopener,noreferrer'); return; }
        opener = button;
        mediaContainer.replaceChildren();
        get('[data-review-media-title]').textContent = (kind === 'video' ? 'Video' : 'Photo') + ' from ' + review.author;
        var media = element(kind === 'video' ? 'video' : 'img');
        if (kind === 'video') { media.controls = true; media.playsInline = true; media.preload = 'metadata'; if (poster) media.poster = poster; }
        else { media.alt = 'Customer photo from ' + review.author; }
        media.src = url;
        media.addEventListener('error', function () { media.hidden = true; if (!mediaContainer.querySelector('p')) mediaContainer.appendChild(element('p', '', 'This media could not be loaded. Use the original media link below.')); }, { once: true });
        mediaContainer.appendChild(media);
        originalMedia.href = url;
        dialog.showModal();
        dialogClose.focus();
      }
      function thumbnail(url, kind, review, index, poster) {
        var button = element('button', 'ff-reviews__thumb');
        button.type = 'button';
        button.setAttribute('aria-label', 'Open ' + kind + ' ' + (index + 1) + ' from ' + review.author);
        if (kind === 'photo' || poster) { var img = element('img'); img.src = kind === 'photo' ? url : poster; img.alt = ''; img.loading = 'lazy'; img.width = 86; img.height = 86; img.addEventListener('error', function () { img.remove(); button.appendChild(element('span', '', kind === 'photo' ? 'View photo' : 'Video')); }, { once: true }); button.appendChild(img); }
        if (kind === 'video') { var play = element('span', 'ff-reviews__play', '▶'); play.setAttribute('aria-hidden', 'true'); button.appendChild(play); }
        button.addEventListener('click', function () { showMedia(url, kind, review, button, poster); });
        return button;
      }
      function card(review) {
        var article = element('article', 'ff-reviews__card');
        var identity = element('div', 'ff-reviews__identity');
        identity.appendChild(element('p', 'ff-reviews__author', review.author));
        if (review.verifiedAtSource) { var badge = element('span', 'ff-reviews__verified', '✓ Verified at source'); badge.title = 'Purchase verified by ' + sourceName; identity.appendChild(badge); }
        if (formatDate(review.date)) { var time = element('time', 'ff-reviews__date', formatDate(review.date)); time.dateTime = review.date; identity.appendChild(time); }
        if (review.variant) identity.appendChild(element('span', 'ff-reviews__version', review.variant));
        var content = element('div', 'ff-reviews__content');
        var stars = element('div', 'ff-reviews__stars', '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating));
        stars.setAttribute('role', 'img'); stars.setAttribute('aria-label', review.rating + ' out of 5 stars'); content.appendChild(stars);
        if (review.title) content.appendChild(element('h3', '', review.title));
        if (review.body) content.appendChild(element('p', 'ff-reviews__body', review.body));
        if (review.images.length || review.videos.length) { var row = element('div', 'ff-reviews__media'); review.images.forEach(function (url, index) { row.appendChild(thumbnail(url, 'photo', review, index)); }); review.videos.forEach(function (url, index) { row.appendChild(thumbnail(url, 'video', review, index, review.videoPosters[index])); }); content.appendChild(row); }
        if (review.response) { var response = element('div', 'ff-reviews__response'); response.appendChild(element('h4', '', 'Response from ' + sourceName)); response.appendChild(element('p', '', review.response.body)); if (formatDate(review.response.date)) { var responseTime = element('time', '', formatDate(review.response.date)); responseTime.dateTime = review.response.date; response.appendChild(responseTime); } content.appendChild(response); }
        article.append(identity, content);
        return article;
      }
      function filteredReviews() {
        return reviews.filter(function (review) {
          return review.rating >= 4 && (!selectedStars || review.rating === selectedStars) && (!variantSelect.value || review.variant === variantSelect.value) && (!mediaOnly.checked || review.images.length || review.videos.length);
        }).sort(function (a, b) {
          if (sortSelect.value === 'highest') return b.rating - a.rating || b.timestamp - a.timestamp || a.sourceIndex - b.sourceIndex;
          if (sortSelect.value === 'lowest') return a.rating - b.rating || b.timestamp - a.timestamp || a.sourceIndex - b.sourceIndex;
          if (sortSelect.value === 'oldest') return a.timestamp - b.timestamp || a.sourceIndex - b.sourceIndex;
          return b.timestamp - a.timestamp || a.sourceIndex - b.sourceIndex;
        });
      }
      function render(reset) {
        if (reset) visibleLimit = 6;
        var filtered = filteredReviews();
        list.replaceChildren();
        filtered.slice(0, visibleLimit).forEach(function (review) { list.appendChild(card(review)); });
        var shown = Math.min(visibleLimit, filtered.length);
        status.textContent = filtered.length ? 'Showing ' + shown + ' of ' + filtered.length + ' selected reviews' + (selectedStars ? ' rated ' + selectedStars + ' stars.' : ' rated 4–5 stars.') : 'No selected 4–5-star reviews match these filters. Try another version or clear filters.';
        moreButton.hidden = shown >= filtered.length;
        clearButton.hidden = !selectedStars && !variantSelect.value && !mediaOnly.checked;
        distribution.querySelectorAll('button').forEach(function (button) { button.setAttribute('aria-pressed', Number(button.dataset.rating) === selectedStars ? 'true' : 'false'); });
      }
      function renderSource(data) {
        sourceName = cleanText(data.sourceName) || 'the original store';
        var sourceUrl = httpsUrl(data.sourceUrl);
        source.replaceChildren(document.createTextNode('Only selected 4–5-star reviews are shown. Scores and counts apply to this selection. Reviews originally posted on '));
        if (sourceUrl) { var link = element('a', '', sourceName); link.href = sourceUrl; link.target = '_blank'; link.rel = 'noopener noreferrer'; source.appendChild(link); } else source.appendChild(document.createTextNode(sourceName));
        source.appendChild(document.createTextNode('. Purchase verification refers to that store.'));
        source.hidden = false;
      }
      function renderSummary() {
        var histogram = { 4: 0, 5: 0 };
        var sum = 0, photos = 0, videos = 0;
        reviews.forEach(function (review) { histogram[review.rating] += 1; sum += review.rating; photos += review.images.length; videos += review.videos.length; });
        var average = (sum / reviews.length).toFixed(1);
        get('[data-review-average]').textContent = average;
        get('[data-review-rating-label]').textContent = average + ' out of 5 stars · selected reviews';
        get('[data-review-count]').textContent = reviews.length + (reviews.length === 1 ? ' selected 4–5-star review' : ' selected 4–5-star reviews');
        get('[data-review-media-count]').textContent = [photos ? photos + (photos === 1 ? ' photo' : ' photos') : '', videos ? videos + (videos === 1 ? ' video' : ' videos') : ''].filter(Boolean).join(' · ');
        distribution.replaceChildren();
        for (var stars = 5; stars >= 4; stars--) {
          var button = element('button', 'ff-reviews__star-filter'); button.type = 'button'; button.dataset.rating = stars; button.setAttribute('aria-pressed', 'false'); button.setAttribute('aria-label', 'Show ' + histogram[stars] + ' reviews rated ' + stars + ' stars');
          button.appendChild(element('span', '', stars + ' ★'));
          var bar = element('span', 'ff-reviews__bar'); bar.setAttribute('aria-hidden', 'true'); var fill = element('span'); fill.style.width = ((histogram[stars] / reviews.length) * 100) + '%'; bar.appendChild(fill); button.appendChild(bar); button.appendChild(element('span', 'ff-reviews__star-total', histogram[stars]));
          button.addEventListener('click', function (event) { var value = Number(event.currentTarget.dataset.rating); selectedStars = selectedStars === value ? 0 : value; render(true); }); distribution.appendChild(button);
        }
        var variants = Array.from(new Set(reviews.map(function (review) { return review.variant; }).filter(Boolean))).sort();
        variants.forEach(function (variant) { var option = element('option', '', variant); option.value = variant; variantSelect.appendChild(option); });
        overview.hidden = false; controls.hidden = false;
      }
      async function load() {
        if (state === 'loading' || state === 'loaded') return;
        state = 'loading'; retryButton.hidden = true; status.textContent = 'Loading selected reviews…';
        var abort = typeof AbortController === 'function' ? new AbortController() : null;
        var timeout = window.setTimeout(function () { if (abort) abort.abort(); }, 20000);
        try {
          var response = await fetch(feedUrl, { credentials: 'omit', signal: abort ? abort.signal : undefined });
          if (!response.ok) throw new Error('Reviews unavailable');
          var data = await response.json();
          if (!data || !Array.isArray(data.reviews) || String(data.productId).split('/').pop() !== String(root.dataset.productId).split('/').pop()) throw new Error('Product mismatch');
          reviews = data.reviews.map(normalizedReview).filter(function (review) { return review && review.rating >= 4; });
          renderSource(data);
          state = 'loaded';
          if (!reviews.length) { overview.hidden = true; controls.hidden = true; get('[data-review-average]').textContent = ''; get('[data-review-rating-label]').textContent = ''; get('[data-review-count]').textContent = '0 selected 4–5-star reviews'; get('[data-review-media-count]').textContent = ''; status.textContent = 'No selected 4–5-star reviews for this kit yet. Share your build with us.'; return; }
          renderSummary(); render(true);
        } catch (error) { state = 'failed'; status.textContent = 'Selected reviews could not be loaded right now. Please try again.'; retryButton.hidden = false; }
        finally { window.clearTimeout(timeout); }
      }
      variantSelect.addEventListener('change', function () { render(true); });
      sortSelect.addEventListener('change', function () { render(true); });
      mediaOnly.addEventListener('change', function () { render(true); });
      clearButton.addEventListener('click', function () { selectedStars = 0; variantSelect.value = ''; mediaOnly.checked = false; render(true); });
      moreButton.addEventListener('click', function () { var previous = visibleLimit; visibleLimit += 6; render(false); var next = list.children[previous]; if (next) { next.tabIndex = -1; next.focus({ preventScroll: true }); } });
      retryButton.addEventListener('click', load);
      if ('IntersectionObserver' in window) { observer = new IntersectionObserver(function (entries) { if (entries.some(function (entry) { return entry.isIntersecting; })) { observer.disconnect(); load(); } }, { rootMargin: '400px 0px' }); observer.observe(root); }
      else load();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
